import Utils from "../utils/Utils";
import { findBusinessProfileId, isApiError, isSuccessResponse } from "./registrationHelpers";

export const getPastryBusinessProfileIds = async () => {
  // Restore the original Pastry flow's public lookup before account creation,
  // without changing authentication for any existing controller callers.
  const response = await Utils.controller(
    "api/businessProfile/v1/getBusinessProfileTypesAndCategories",
    "", "GET", "", false, "", true,
  );
  if (isApiError(response) || !isSuccessResponse(response)) {
    throw new Error("Business profiles could not be loaded. Please try again.");
  }
  const data = response?.data?.data ?? response?.data?.result ?? response?.data;
  const labels = ["Pastry", "Patisserie", "Pastries"];
  const findId = (items, key) => labels.map(label => findBusinessProfileId(items, key, label)).find(Boolean);
  const businessProfileTypeId = findId(data?.businessProfileTypes, "businessProfileTypeId");
  const businessProfileCategoryId = findId(data?.businessProfileCategories, "businessProfileCategoryId");
  if (!businessProfileTypeId || !businessProfileCategoryId) {
    throw new Error("Pastry business type or category is unavailable. Please try again later.");
  }
  return { businessProfileTypeId, businessProfileCategoryId };
};
